import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appModalContentDirective]'
})
export class ModalContentDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }
}
